import { api } from '../../../configuration'
import { deleteRestRequest } from '../../../helpers/RestHelpers'
import { classifiedTransformer } from '../../transformers/classifiedTransformer'
import { SimpleResult } from '../../types/PaginatedResult'
import { SClassified } from '../../types/api/Classified'

type RemoveResponse = SimpleResult<SClassified>

export type RemoveParams = {
  id: number
}

const remove = ({ id }: RemoveParams) => {
  return deleteRestRequest({
    url: `${api.REST_API_URL}/classifieds/${id}`,
    transformer: (response: RemoveResponse) =>
      classifiedTransformer(response.data),
  })
}

export default remove
